import React from "react";
import PrivacyPolicyDetails from "../../../condition-details/PrivacyPolicyDetails";
import RightSideSettingsWrapper from "../../rightside-details-settings/RightSideSettingsWrapper";

const PrivacyPolicySetting = (props) => {
  return (
    <RightSideSettingsWrapper>
      <PrivacyPolicyDetails uiChangeConditions={"ui-change"} />
    </RightSideSettingsWrapper>
  );
};

export default PrivacyPolicySetting;
